module.exports = __webpack_public_path__ + "img/1728609446797-Screenshot_11-10-2024_9179_www.instagram.com.jpeg.76adfd0c.webp";